<template>
  <div>
    <div id="login" v-if="type!='/mobile'">
      <img src="../assets/images/login.jpg" alt="" class="login-bg">
      <div class="logo-box">
        <img src="../assets/images/logo-1.png" alt="">
        <!-- <h3>{{$store.state.title}}</h3> -->
      </div>
      <div class="form-box">
        <p class="title">登陆/Login</p>
        <template>
          <a-input placeholder="请输入用户名" v-model="userName" class="input-box"/>
        </template>
        <template>
          <a-input-password placeholder="请输入密码" v-model="password" class="input-box"/>
        </template>
        <a-button type="primary" @click="login">登录</a-button>
      </div>
    </div>
    <div id="login" v-if="type=='/mobile'">
      <img src="../assets/images/login-mobile.jpg" alt="" class="login-bg">
      <div class="logo-box-mobile">
        <img src="../assets/images/logo.png" alt="">
        <!-- <h3>{{$store.state.title}}</h3> -->
      </div>
      <div class="mobile-form">
        <van-form @submit="login">
            <van-field
              style="background:#f7f8fa"
              v-model="userName"
              name="用户名"
              label="用户名"
              placeholder="用户名"
            />
            <van-field
              style="background:#f7f8fa"
              v-model="password"
              type="password"
              name="密码"
              label="密码"
              placeholder="密码"
            />
            <div style="margin: 16px;">
              <van-button round block type="info" native-type="submit">登录</van-button>
            </div>
          </van-form>
      </div>
 <!--      <div class="form-box-mobile">

        <p class="title">移动端登陆/Login</p>
        <template>
          <a-input placeholder="请输入用户名" v-model="userName" class="input-box"/>
        </template>
        <template>
          <a-input-password placeholder="请输入密码" v-model="password" class="input-box"/>
        </template>
        <a-button type="primary" @click="login">登录</a-button> 
      </div>-->
    </div>
  </div>
</template>

<script>
import { Login } from '@/baseAPI/login'
import aes from '@/assets/js/aes'
  export default {
    name: 'login',
    data () {
      return {
        userName:'',
        password:'',
        type:'pc'
      }
    },
    components: {
    },
    mounted () {
      this.type = this.$route.query.path;
    },
    methods:{
      login(){
        if(this.userName!=''&&this.password!='')
        {
          const hide = this.$message.loading('登录中', 0);
          Login({username:this.userName,password:aes.encrypt(this.password,'1234567890ECDATA')}).then(res => {
            setTimeout(hide, 0);
            this.$store.commit('set',{name:'access_token',val:res.data.access_token});
            this.$store.commit('set',{name:'login',val:res.data});
            localStorage.setItem("access_token", res.data.access_token);
            var date=new Date();
            var time=date.getTime();
            localStorage.setItem("tokenTime",time);
            localStorage.setItem('tokenTerm',res.data.expires_in*1000)
            this.$message.success('登录成功');
            var url=typeof this.$route.query.path=='undefined'?'/':this.$route.query.path
            this.$router.push(url)
          }).catch(()=>{
            setTimeout(hide, 0);
            this.$notification.error({
              message: '错误',
              description: '用户名或密码错误',
              duration: 3
            })
          })
        }
        else if(this.userName=='')
        {
          this.$notification.warning({
            message: '警告',
            description: '用户名不能为空',
            duration: 3
          })
        }
        else if(this.password=='')
        {
          this.$notification.warning({
            message: '警告',
            description: '密码不能为空',
            duration: 3
          })
        }
      },
    }
  }
</script>

<style scoped>
  #login
  {
    width: 100vw;
    height: 100vh;
    /* background-color: #1b2b7d; */
    position: relative;
    overflow: hidden;
  }
  .login-bg
  {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: -1;
  }
  .logo-box
  {
    padding-top: 3rem;
    padding-left: 3rem;
    display: flex;
    align-items: center;
  }

  .logo-box-mobile
  {
    padding-top: 3rem;
    padding-left: 3rem;
    display: flex;
    align-items: center;
  }

  .logo-box-mobile img
  {
    width: 70%;
    margin-left: 15%;
    margin-top: 30%;
    display: inline-block;
  }
  .logo-box-mobile h3
  {
    display: inline-block;
    font-size: 1.8rem;
    color: #fff;
    vertical-align: bottom;
    margin: 0;
    margin-left: 1rem;
  }

  .logo-box img
  {
    width: 9rem;
    display: inline-block;
  }
  .logo-box h3
  {
    display: inline-block;
    font-size: 1.8rem;
    color: #fff;
    vertical-align: bottom;
    margin: 0;
    margin-left: 1rem;
  }
  .form-box
  {
    padding: 2.5rem 2.5rem;
    width: 23%;
    height: 32%;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 14%;
    margin: auto 0;
    background-color: #fff;
    box-shadow: 0 0 15px 2px #0874FF;
  }
  .form-box .input-box
  {
    margin-top: 1.5rem;
  }
  .form-box .ant-btn
  {
    margin-top: 2.5rem;
    width: 100%;
  }

  .form-box-mobile
  {
    padding: 2.5rem 2.5rem;
    width: 90%;
    height: 40%;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 5%;
    margin: auto 0;
    background-color: #fff;
    box-shadow: 0 0 15px 2px #0874FF;
  }
  .form-box-mobile .input-box
  {
    margin-top: 1.5rem;
  }
  .form-box-mobile .ant-btn
  {
    margin-top: 2.5rem;
    width: 100%;
  }

  .mobile-form{
    padding: 2.5rem 2.5rem;
    width: 90%;
    height: 24%;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 5%;
    margin: 80% 0 0 0;
    /* background-color: #fff; */
    box-shadow: 0 0 15px 2px #0874FF;
  }
</style>
